import { Radio } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Input from "../../shared/Input";
import EditIcon from "../../../assets/img/dashboard/edit-2.svg";
import phoneIcon from "../../../assets/img/dashboard/call-received.svg";
import Textarea from "../../shared/Textarea";
import Button from "../../shared/Button";
import EditProfileHeader from "./EditProfile/EditProfileHeader";
import useFetch from "../../../hooks/useAxios";
import { useUserInfo } from "../../../context/UserContext";
import { toast } from "react-hot-toast";
import { data } from "autoprefixer";
import ImageInput from "../../shared/ImageInput";
const EditProfile = () => {
  const [profileInfo, setprofileInfo] = useState();
  const [profileData, setProfileData] = useState();
  const [IDCard, setIDCard] = useState();
  const [certificate, setCertificate] = useState();

  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm({
    defaultValues: useMemo(
      () => {
        return profileInfo;
      },
      [profileInfo]
    )
  });
  const { userinfo } = useUserInfo();
  const fetchprofile = useFetch({
    method: "get",
    url: `api/profile`,
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setprofileInfo(res.data.profile);
      setavatar(res.data.avatar);
      setgender(res.data.profile.sex);
      setIDCard(res.data.profile.national_code);
      setCertificate(res.data.profile.foriegn_document);
      reset({
        first_name: res.data.profile.first_name,
        last_name: res.data.profile.last_name,
        national_code: res.data.profile.national_code,
        email: res.data.profile.email,
        phone: res.data.profile.phone,
        iban: res.data.profile.iban,
        about_me: res.data.profile.about_me,
        password: "....."
      });
    }
  });
  useEffect(
    () => {
      if (profileInfo) {
        reset({
          first_name: profileInfo.first_name,
          last_name: profileInfo.last_name,
          national_code: profileInfo.national_code,
          email: profileInfo.email,
          phone: profileInfo.phone,
          iban: profileInfo.iban,
          about_me: profileInfo.about_me,
          password: "........"
        });
      }
    },
    [profileInfo]
  );

  const postprofile = useFetch({
    method: "post",
    url: `api/profile/update`,
    noHeader: false,
    trigger: false,
    caller: fetchprofile,
    data: profileData,
    argFunc: res => {
      toast.success("پروفایل شما با موفقیت بروزرسانی شد.");
    },
    errMessage: err => {
      if (err.response.data.errors.sex) {
        for (let x of err.response.data.errors.sex) {
          toast.error(x);
        }
      }  if (err.response.data.errors.national_code) {
        for (let x of err.response.data.errors.national_code) {
          toast.error(x);
        }
      }  if (err.response.data.errors.phone) {
        for (let x of err.response.data.errors.phone) {
          toast.error(x);
        }
      }  if (err.response.data.errors.password) {
        for (let x of err.response.data.errors.password) {
          toast.error(x);
        }
      }
        if (err.response.data.errors.foriegn_document) {
        for (let x of err.response.data.errors.foriegn_document) {
          toast.error(x);
        }
      }
      if (err.response.data.errors.national_card) {
        for (let x of err.response.data.errors.national_card) {
          toast.error(x);
        }
      }
    }
  });
  const [avatar, setavatar] = useState();
  const [avatarDatas, setavatarDatas] = useState();

  const postAvatar = useFetch({
    method: "post",
    url: `api/profile/avatar`,
    noHeader: false,
    trigger: false,

    data: avatarDatas,
    argFunc: res => {
      toast.success("تصویر نمایه ی شما با موفقیت بروزرسانی شد.");
    }
  });
  const [gender, setgender] = useState("male");
  const onChange = e => {
    setgender(e.target.value);
    console.log(gender);
  };
  const onSubmit = data => {
    const formData = new FormData();
    const avatarData = new FormData();
    if (data.password === ".....") {
      formData.append("first_name", data.first_name);
      formData.append("last_name", data.last_name);
      formData.append("national_code", data.national_code);
      formData.append("email", data.email);
      formData.append("phone", data.phone);
      formData.append("password", null);
      formData.append("about_me", data.about_me);
      formData.append("sex", gender);
      if (typeof IDCard !== "string") {
        formData.append("national_card", IDCard);
      }
      if (typeof certificate !== "string") {
        formData.append("foriegn_document", certificate);
      }
    } else {
      formData.append("first_name", data.first_name);
      formData.append("last_name", data.last_name);
      formData.append("national_code", data.national_code);
      formData.append("email", data.email);
      formData.append("phone", data.phone);
      formData.append("password", data.password);
      formData.append("about_me", data.about_me);
      formData.append("sex", gender);
      if (typeof IDCard !== "string") {
        formData.append("national_card", IDCard);
      }
    }

    setProfileData(formData);
  };
  useEffect(
    () => {
      if (profileData) {
        postprofile.reFetch();
      }
    },
    [profileData]
  );

  useEffect(
    () => {
      if (typeof avatar !== "string" && avatar) {
        postAvatar.reFetch();
      }
    },
    [avatarDatas]
  );
  console.log(IDCard, "ID");
  return (
    <div>
      <EditProfileHeader
        file={avatar}
        profileInfo={profileInfo}
        setfile={setavatar}
        setavatarDatas={setavatarDatas}
      />
      <div className="EditProfile">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <p className="name__p">نام و نام خانوادگی</p>
            <p className="name__des">
              نام و نام خانوادگی برای سایر کاربر های جاتیک قابل مشاهده است .
            </p>
            <div className="EditProfile--grid">
              <Input
                name="first_name"
                control={control}
                errors={errors}
                className="seconadary-input "
                register={{
                  required: "  نام اجباری است"
                }}
                psIcon={<img src={EditIcon} />}
              />
              <Input
                name="last_name"
                control={control}
                errors={errors}
                className="seconadary-input"
                register={{
                  required: " نام خانوادگی اجباری  است"
                }}
                psIcon={<img src={EditIcon} />}
              />
            </div>
          </div>
          <Input
            name="national_code"
            control={control}
            errors={errors}
            placeholder=" اطلاعاتی وارد نشده"
            label="کد ملی"
            className="seconadary-input my-[20px]"
            register={{
              required: "  کد ملی اجباری است"
            }}
            psIcon={<img src={EditIcon} />}
          />
          <div className="mb-[20px]">
            <p className="name__p">جنسیت شما</p>
            <Radio.Group
              //  defaultValue={createInfoData.stepTwo.gender}
              onChange={onChange}
              value={gender}
            >
              <div className="createstep2--grid">
                <div
                  className={`createsteps--radiogroupbox ${gender === "male"
                    ? "createsteps--radiogroupbox--active"
                    : ""}`}
                >
                  <Radio value="male">
                    <div className={`createsteps--radiogrouplabel`}>
                      من آقا هستم
                    </div>
                  </Radio>
                </div>
                <div
                  className={`createsteps--radiogroupbox ${gender === "female"
                    ? "createsteps--radiogroupbox--active"
                    : ""}`}
                >
                  <Radio value="female">
                    <div className="createsteps--radiogrouplabel">
                      من خانم هستم
                    </div>
                  </Radio>
                </div>
              </div>
            </Radio.Group>
          </div>
          <Input
            name="email"
            control={control}
            errors={errors}
            placeholder="آدرس ایمیل"
            label="آدرس ایمیل"
            type="email"
            className="seconadary-input mb-[20px]"
            register={{
              required: " آدرس ایمیل اجباری است"
            }}
            psIcon={<img src={EditIcon} />}
          />{" "}
          <Input
            LabelIcon={<img src={phoneIcon} />}
            name="phone"
            control={control}
            errors={errors}
            placeholder=" ۰۹۳۳۰۴۳۷۸۵۷"
            label="شماره تماس"
            className="seconadary-input mb-[20px]"
            register={{
              required: " عنوان اقامتگاه اجباری است"
            }}
            psIcon={<img src={EditIcon} />}
          />
          <Input
            name="password"
            control={control}
            errors={errors}
            placeholder=" رمز عبور ثابت"
            type="password"
            label="رمز عبور ثابت"
            className="seconadary-input mb-[20px]"
            psIcon={<img src={EditIcon} />}
          />
          <div className="grid md:grid-cols-2 grid-cols-1 gap-[31px]">
            <ImageInput
              file={IDCard}
              id="3"
              setfile={setIDCard}
              text="آپلود کارت ملی"
              label="تصویر کارت ملی"
              placeholder="تصویری وارد نشده"
            />
            <ImageInput
              file={certificate}
              id="4"
              setfile={setCertificate}
              text="آپلود مجوز"
              label="فایل گردشگر خارجی"
              placeholder="تصویری وارد نشده"
            />
          </div>
          <Textarea
            name="about_me"
            control={control}
            errors={errors}
            label="معرفی مختصر من"
            className="seconadary-input mt-[50px]"
            rows="5"
          />
          <div className="flex justify-end gap-[30px] mt-[40px]">
            <Button varient="gray">انصراف </Button>

            <Button varient="primary">ثبت اطلاعات</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfile;
